import { Box, Grid, Typography } from '@mui/material';
import { ApplicationProps } from '../../redux-store/types/api-types';
import { KeyValue } from './contributor';
import { Gridstyles } from './index';
import {
  currencyConversion,
  isChequeOrRTGS,
  isFieldApplicable,
  isNEFT,
} from '../../utils/utilityFunctions';
import {
  DISTRIBUTION_FEE_TYPE_MASTER,
  INVESTMENT_METHOD_MASTER,
  MODE_OF_PAYMENT_MASTER,
  SIP_MASTER,
} from '../../utils/constant';
import { styles } from '../../Styles/styles';
import { SubHeading } from '../investors/components';
import { formatShortDate } from '../../utils/date';

export default function InvestAndPaymentDetails({
  application,
}: {
  application: Partial<ApplicationProps>;
}): JSX.Element {
  return (
    <>
      <Box sx={styles.ApplicationDetailsCommonLayout} mt={5}>
        <Box sx={{ p: 2 }}>
          <Grid container sx={{ mt: 1, pl: { xs: 2, sm: 10 }, pr: { xs: 2, sm: 10 } }}>
            <Typography sx={{ fontSize: 18, fontWeight: 600, color: 'primary.main' }}>
              Investment Details
            </Typography>
            <Gridstyles>
              <Grid
                item
                container
                pt={2}
                rowSpacing={6}
                columnSpacing={13}
                direction="row"
                justifyContent="space-between"
                alignItems="flex-start">
                <KeyValue title={'Fund (Scheme)'} description={application.scheme?.schemeName} />
                <KeyValue
                  title={'Mode Of Investment'}
                  description={INVESTMENT_METHOD_MASTER[application?.modeOfInvestment || '']}
                />
                <KeyValue
                  title={'Investment Percentage'}
                  description={application?.investmentPercentage}
                />
                {application?.investmentMonths && (
                  <KeyValue
                    title={'Investment Months'}
                    description={application?.investmentMonths}
                  />
                )}
                <KeyValue title={'Class Plan'} description={application.plan?.planDescription} />
                <KeyValue
                  title={'Commitment Amount'}
                  description={application.commitmentAmount}
                  amount={currencyConversion(
                    application.commitmentAmount,
                    application.plan?.currency
                  )}
                />
                <KeyValue
                  title={'Management Fees Rate'}
                  description={application.managementFeesRate}
                />
                {/* <KeyValue title={'Tax Rate'} description={application.taxRate} /> */}
                {/* <KeyValue title={'DrawDown Number'} description={application.drawDownNumber} /> */}
                <KeyValue
                  title={'Initial Contribution Amount'}
                  description={application.contributionChequeAmount}
                  amount={currencyConversion(
                    application.contributionChequeAmount,
                    application.plan?.currency
                  )}
                />
                <KeyValue
                  title={'Setup Fee Percentage'}
                  description={application.setupFeePercentage}
                />
                <KeyValue
                  title={'Setup Fee Amount'}
                  description={application.setupFeeAmount}
                  amount={currencyConversion(
                    application.setupFeeAmount,
                    application.plan?.currency
                  )}
                />
                {/* <KeyValue
                  title={'GST (GST On Setup Fee Amount)'}
                  description={application.setupFeeGST}
                  amount={currencyConversion(application.setupFeeGST, application.plan?.currency)}
                /> */}
                {/* <KeyValue
                  title={'Total Setup Fee'}
                  description={application.totalSetupFee}
                  amount={currencyConversion(application.totalSetupFee, application.plan?.currency)}
                /> */}
                {/* <KeyValue
                  title={'TDS'}
                  description={application.setupFeeTDS}
                  amount={currencyConversion(application.setupFeeTDS, application.plan?.currency)}
                /> */}
                {/* <KeyValue
                  title={'Setup Fee Payable'}
                  description={application.netSetupFeeLessTDS}
                  amount={currencyConversion(
                    application.netSetupFeeLessTDS,
                    application.plan?.currency
                  )}
                /> */}
                <KeyValue
                  title={'Total Amount Payable'}
                  description={application.totalAmountPayable}
                  amount={currencyConversion(
                    application.totalAmountPayable,
                    application.plan?.currency
                  )}
                />
                {/* <KeyValue title={'SIP'} description={SIP_MASTER[application.sip || '']} /> */}
                <KeyValue
                  title={'Mode Of Payment'}
                  description={MODE_OF_PAYMENT_MASTER[application.modeOfPayment || '']}
                />
                {isChequeOrRTGS(application.modeOfPayment || '') && (
                  <KeyValue title={'Cheque No/UTR No'} description={application.paymentRefNo} />
                )}
                {isNEFT(application.modeOfPayment || '') && (
                  <KeyValue title={'NEFT Code'} description={application.neftCode} />
                )}
                <KeyValue
                  title={'Instrument Date'}
                  description={formatShortDate(application.paymentRefDate)}
                />
                <KeyValue title={'Placement Fee (%)'} description={application?.placementFee} />
                {application.scheme?.schemeCode === 'CO' && (
                  <>
                    <KeyValue
                      title={'Distribution Fee Type'}
                      description={
                        DISTRIBUTION_FEE_TYPE_MASTER[application?.distributorFeeType || '']
                      }
                    />
                    {DISTRIBUTION_FEE_TYPE_MASTER[application.distributorFeeType || ''] ==
                      DISTRIBUTION_FEE_TYPE_MASTER.upfront_plus_trail && (
                      <KeyValue
                        title={`Enter ${
                          DISTRIBUTION_FEE_TYPE_MASTER[application?.distributorFeeType || '']
                        } (%)`}
                        description={application?.upfrontPlusTrail}
                      />
                    )}
                  </>
                )}
                {DISTRIBUTION_FEE_TYPE_MASTER[application.distributorFeeType || ''] !=
                  DISTRIBUTION_FEE_TYPE_MASTER.upfront_plus_trail && (
                  <KeyValue
                    title={`${
                      application.scheme?.schemeCode === 'CO'
                        ? DISTRIBUTION_FEE_TYPE_MASTER[application?.distributorFeeType || '']
                        : 'Distribution Fee (%)'
                    }`}
                    description={application?.distributorFee}
                  />
                )}
                {isFieldApplicable(application?.hurdleRateApplicable || '') && (
                  <KeyValue title={'Hurdle Rate %'} description={application?.hurdleRate} />
                )}
                {isFieldApplicable(application?.performanceFeeApplicable || '') && (
                  <KeyValue title={'Performance Fee %'} description={application?.performanceFee} />
                )}
              </Grid>
            </Gridstyles>
            <SubHeading
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}>
              Drawn on Bank Details
            </SubHeading>
            <Gridstyles>
              <Grid
                item
                container
                pt={2}
                rowSpacing={6}
                columnSpacing={13}
                direction="row"
                justifyContent="space-between"
                alignItems="flex-start">
                <KeyValue title={'Drawn On Bank'} description={application.drawnOnBank} />
                <KeyValue title={'Account Number'} description={application.drawnAccountNumber} />
                <KeyValue title={'Bank Branch'} description={application.drawnBankBranch} />
                <KeyValue title={'City'} description={application.drawnCity} />
              </Grid>
            </Gridstyles>
          </Grid>
        </Box>
        <Box sx={{ p: 2 }}>
          {/* <Grid container sx={{ mt: 1, pl: { xs: 2, sm: 10 }, pr: { xs: 2, sm: 10 } }}>
            <Typography sx={{ fontSize: 18, fontWeight: 600, color: 'primary.main' }}>
              Payment Details
            </Typography>
            <Gridstyles>
              <Grid
                item
                container
                pt={2}
                pb={5}
                rowSpacing={6}
                columnSpacing={13}
                direction="row"
                justifyContent="space-between"
                alignItems="flex-start">
                <KeyValue title={'Payment Bank Name'} description={application.paymentBankame} />
                <KeyValue
                  title={'Payment Bank Account Number'}
                  description={application.paymentBankAccountNumber}
                />
                <KeyValue
                  title={'Payment Bank Account Type'}
                  description={application.paymentBankAccontType}
                />
                <KeyValue title={'Mode Of Payment'} description={application.modeOfPayment} />
                <KeyValue
                  title={'Payment/Cheque Date'}
                  description={formatShortDate(application.chequeDate)}
                />
                <KeyValue title={'Payment Ref No'} description={application.paymentRefNo} />
              </Grid>
            </Gridstyles>
          </Grid> */}
        </Box>
      </Box>
    </>
  );
}
